export default __webpack_public_path__ + "static/media/mn_tea_sub_10.21cda74c.png";